import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  VStack,
  Button,
  FormControl,
  FormLabel,
  Text,
  Badge,
  HStack,
} from "@chakra-ui/react";

export default function UsuarioDetalhesModal({ isOpen, onClose, user }) {
  if (!user) {
    return null;
  }

  const formatRegisterDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("pt-BR");
    } catch (e) {
      console.error("Erro ao formatar data:", e);
      return dateString;
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          bg="red.600"
          color="white"
          borderTopRadius="lg"
          textAlign="center"
          py={4}
        >
          Detalhes do Usuário
        </ModalHeader>
        <ModalBody p={6}>
          <VStack spacing={4} align="stretch">
            <FormControl>
              <FormLabel fontWeight="bold" color="gray.700">
                Nome Completo:
              </FormLabel>
              <Input
                value={user.name || "N/A"}
                isReadOnly
                variant="filled"
                bg="gray.50"
              />
            </FormControl>

            <FormControl>
              <FormLabel fontWeight="bold" color="gray.700">
                Login:
              </FormLabel>
              <Input
                value={user.login || "N/A"}
                isReadOnly
                variant="filled"
                bg="gray.50"
              />
            </FormControl>

            <FormControl>
              <FormLabel fontWeight="bold" color="gray.700">
                Cargo:
              </FormLabel>
              <Input
                value={user.position?.description || "N/A"}
                isReadOnly
                variant="filled"
                bg="gray.50"
              />
            </FormControl>

            <FormControl>
              <FormLabel fontWeight="bold" color="gray.700">
                Status:
              </FormLabel>
              <Badge
                colorScheme={
                  user.status?.description?.toLowerCase() === "ativo"
                    ? "green"
                    : "red"
                }
                fontSize="0.9em"
                px={3}
                py={1}
                borderRadius="full"
                textTransform="uppercase"
                fontWeight="bold"
                display="inline-flex"
                alignItems="center"
                justifyContent="center"
                mt={1}
              >
                {user.status?.description || "N/A"}
              </Badge>
            </FormControl>

            <FormControl>
              <FormLabel fontWeight="bold" color="gray.700">
                Função (Role):
              </FormLabel>
              <Input
                value={user.role?.description || "N/A"}
                isReadOnly
                variant="filled"
                bg="gray.50"
              />
            </FormControl>

            <FormControl>
              <FormLabel fontWeight="bold" color="gray.700">
                Empresa :
              </FormLabel>
              <Input
                value={user.company?.description || "N/A"}
                isReadOnly
                variant="filled"
                bg="gray.50"
              />
            </FormControl>

            <FormControl>
              <FormLabel fontWeight="bold" color="gray.700">
                Data de Registro:
              </FormLabel>
              <Input
                value={formatRegisterDate(user.registerDate)}
                isReadOnly
                variant="filled"
                bg="gray.50"
              />
            </FormControl>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button
            colorScheme="red"
            onClick={onClose}
            px={6}
            py={3}
            borderRadius="md"
            boxShadow="md"
            _hover={{ bg: "red.700" }}
          >
            Fechar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
